<template>
    <div>
    <a-modal modal-id="edit-status">
      <div slot="title">Edit Task Status</div>
      <div slot="form">
        <div class="row m-t-xs">
          <label>Status</label>
          <v-select :options="status" label="label" index="index" v-model="task.status"></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Message</label>
          <textarea class="form-control" cols="30" rows="5" v-model="statusMessage"></textarea>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-primary pull-right" @click="editStatus">Edit Status</button>
      </div>
    </a-modal>
    <div class="row">
      <div class="col-lg-12">
        <div class="m-b-md">
          <div v-if="task.archived" style="background-color: #FFDFDDFF">
            <span class="large-font line-through">{{ task.title || 'Task' }}</span>
            <i class="fa fa-exclamation-triangle m-l-sm red fa-lg" v-tooltip="'This task has been deleted'"></i>
          </div>
          <div v-else class="flex-space-between">
            <h2 v-if="canEdit">
              <a-edit-txt type="text" :text="task.title" @input="updateProperty($event, 'title')" close-on-save="true"></a-edit-txt>
            </h2>
            <h2 v-else>{{ task.title }}</h2>
            <button v-if="canEdit" class="btn btn-xs btn-danger pull-right m-r-xs" @click="deleteTask">Delete Task</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <dl class="row mb-0" v-if="task.slug && !task.slug.includes('undefined')">
          <div class="col-sm-4 text-sm-right">
            <dt>Slug:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <dd class="mb-1">
              <strong><span>{{ task.slug }}</span></strong>
            </dd>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Status:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <dd v-if="canEdit">
              {{ task.status || '/' }}
              <a data-toggle="modal" data-target="#edit-status" @click="statusMessage = ''"><i class="fa fa-edit pull-right"></i></a>
            </dd>
            <dd v-else class="mb-1"><span class="label label-primary">{{ task.status || '/' }}</span></dd>
          </div>
        </dl>
        <dl class="row mb-0">
            <div class="col-sm-4 text-sm-right">
                <dt>Priority:</dt>
            </div>
            <div class="col-sm-8 text-sm-left">
              <div id="priority-data">
                <span class="label">{{ task.priority || '/' }}</span>
                <a v-if="canEdit" class="pull-right" @click="toggleEdit('priority-data')"><i class="fa fa-edit"></i></a>
              </div>
              <div id="priority-edit" style="display: none">
                <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                  <v-select
                    :options="priority"
                    label="label" index="index"
                    v-model="task.priority"
                  ></v-select>
                </span>
                <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                  <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.priority, 'priority'); toggleEdit('priority-edit')"><i class="fa fa-save"></i></button>
                  <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('priority-edit')"><i class="fa fa-cancel"></i></button>
                </span>
              </div>
            </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Tags:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <div id="task-tags-data" class="display-block">
              <span v-for="(tag, i) in task.tags" :key="task.id + '-tag-' + i" class="label label-success m-r-xs inline-block">
                {{ tag }}
              </span>
              <a v-if="canEdit" class="pull-right" @click="toggleEdit('task-tags-data')"><i class="fa fa-edit"></i></a>
            </div>
            <div id="task-tags-edit" style="display: none">
              <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <v-select
                  multiple taggable push-tags
                  v-model="task.tags"
                ></v-select>
              </span>
              <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.tags, 'tags'); toggleEdit('task-tags-edit')"><i class="fa fa-save"></i></button>
                <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('task-tags-edit')"><i class="fa fa-cancel"></i></button>
              </span>
            </div>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Client:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <div id="task-client-data">
              <span class="label">{{ task.client ? task.client.name : '/' }}</span>
              <a v-if="canEdit" class="pull-right" @click="toggleEdit('task-client-data')"><i class="fa fa-edit"></i></a>
            </div>
            <div id="task-client-edit" style="display: none">
              <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <v-select
                  :options="f.clients"
                  label="name" index="id"
                  v-model="task.client"
                ></v-select>
              </span>
              <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.client, 'client'); toggleEdit('task-client-edit')"><i class="fa fa-save"></i></button>
                <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('task-client-edit')"><i class="fa fa-cancel"></i></button>
              </span>
            </div>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Departments:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <div id="task-departments-data" class="display-block">
              <span v-for="(dep, i) in task.departments" :key="task.id + '-department-' + i" class="label label-success m-r-xs inline-block">
                {{ dep }}
              </span>
              <a v-if="canEdit" class="pull-right" @click="toggleEdit('task-departments-data')"><i class="fa fa-edit"></i></a>
            </div>
            <div id="task-departments-edit" style="display: none">
              <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <v-select
                  :options="departments" multiple
                  label="label" index="index"
                  v-model="task.departments"
                ></v-select>
              </span>
              <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.departments, 'departments'); toggleEdit('task-departments-edit')"><i class="fa fa-save"></i></button>
                <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('task-departments-edit')"><i class="fa fa-cancel"></i></button>
              </span>
            </div>
          </div>
        </dl>
      </div>
      <div class="col-lg-6">
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Project:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <dd class="mb-1">
              <div id="project-data">
                <span class="label label-success" v-if="task.project && task.project.id">{{ task.project.name }}</span>
                <span v-else>Task does not belong to any project</span>
                <a v-if="canEdit" class="pull-right" @click="toggleEdit('project-data')"><i class="fa fa-edit"></i></a>
              </div>
              <div id="project-edit" style="display: none">
                <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                  <v-select
                    :options="projects"
                    label="name" index="id"
                    v-model="task.project"
                  ></v-select>
                </span>
                <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                  <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.project, 'project'); toggleEdit('project-edit')"><i class="fa fa-save"></i></button>
                  <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('project-edit')"><i class="fa fa-cancel"></i></button>
                </span>
              </div>
            </dd>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Created By:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <dd class="mb-1"><span class="label label-primary">{{ task.creator ? task.creator.username : '/' }}</span></dd>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Requested By:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <div id="task-requestedBy-data">
              <span class="label label-primary">{{ task.requestedBy ? task.requestedBy.username : '/' }}</span>
              <a v-if="canEdit" class="pull-right" @click="toggleEdit('task-requestedBy-data')"><i class="fa fa-edit"></i></a>
            </div>
            <div id="task-requestedBy-edit" style="display: none">
              <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <v-select
                  :options="users"
                  label="username" index="id"
                  v-model="task.requestedBy"
                ></v-select>
              </span>
              <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.requestedBy, 'requestedBy'); toggleEdit('task-requestedBy-edit')"><i class="fa fa-save"></i></button>
                <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('task-requestedBy-edit')"><i class="fa fa-cancel"></i></button>
              </span>
            </div>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Assignee:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <div id="task-assignee-data">
              <span class="label label-primary">{{ task.assignee ? task.assignee.username : '/' }}</span>
              <a v-if="canEdit" class="pull-right" @click="toggleEdit('task-assignee-data')"><i class="fa fa-edit"></i></a>
            </div>
            <div id="task-assignee-edit" style="display: none">
              <span class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <v-select
                  :options="users"
                  label="username" index="id"
                  v-model="task.assignee"
                ></v-select>
              </span>
              <span class="col-lg-2 col-md-2 col-sm-2 col-xs-2 flex-space-between">
                <button class="btn btn-xs btn-success m-r-xs" v-tooltip="'Save changes'" @click="updateProperty(task.assignee, 'assignee'); toggleEdit('task-assignee-edit')"><i class="fa fa-save"></i></button>
                <button class="btn btn-xs btn-danger" v-tooltip="'Cancel edit'" @click="toggleEdit('task-assignee-edit')"><i class="fa fa-cancel"></i></button>
              </span>
            </div>
          </div>
        </dl>
        <dl class="row mb-0">
          <div class="col-sm-4 text-sm-right">
            <dt>Due Date:</dt>
          </div>
          <div class="col-sm-8 text-sm-left">
            <dd v-if="canEdit">
              <a-edit-txt
                type="date"
                :text="task.dueDate"
                @input="updateProperty($event, 'dueDate')"
                close-on-save="true"
              ></a-edit-txt>
            </dd>
            <dd v-else class="mb-1">{{ task.dueDate | aTime() }}</dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <dl class="row mb-0">
          <div class="col-sm-2 text-sm-right">
            <dt>Description:</dt>
          </div>
          <div v-if="canEdit" class="col-sm-10 text-sm-left">
            <dd class="well">
              <a-edit-txt
                type="textarea"
                :text="task.description"
                @input="updateProperty($event, 'description')"
                close-on-save="true"
              ></a-edit-txt>
            </dd>
          </div>
          <div v-else class="col-sm-10 text-sm-left well">
            <dd>
              {{ task.description ? task.description : 'No description entered'}}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <dl class="row mb-0">
          <div class="col-sm-2 text-sm-right">
            <dt>Files:</dt>
          </div>
          <div class="col-sm-10 text-sm-left">
            <dd class="well">
             <file-interface v-if="task.id" :data="task" :type="'tasks'" v-on:reloadData="getTask"></file-interface>
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>
                Task Notes
                <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-notes"><i class="fa fa-plus"></i> Add Note</button>
              </th>
            </tr>
          </thead>
        </table>
        <task-notes v-if="task.id" :task="task" :showLogsOnly="true"></task-notes>
      </div>
      <div class="col-lg-6">
        <table class="table table-striped">
          <thead><tr><th>Change History</th></tr></thead>
        </table>
        <last-activity :hideDetails="true"></last-activity>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import TaskNotes from './TaskNotes.vue'
import LastActivity from './LastActivity.vue'
import { eventBus } from '../../../../../../../main'
import FileInterface from '../../../../../../Helpers/Files/FileInterface.vue'
import { useProjectStore } from '../../../../../../../stores/ProjectStore'
import { storeToRefs } from 'pinia'

export default {
  setup () {
    const projectStore = useProjectStore()
    const { projects } = storeToRefs(projectStore)
    if (!projects.length) projectStore.loadProjects()
    return { projects }
  },
  data () {
    return {
      task: {},
      status: [],
      priority: [],
      departments: [],
      statusMessage: ''
    }
  },
  components: {
    taskNotes: TaskNotes,
    lastActivity: LastActivity,
    fileInterface: FileInterface
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      users: 'getUsers',
      dataStructure: 'getData',
      f: 'getFilters'
    }),
    canEdit () {
      return (
        this.user.admin ||
        this.task.participants.map(el => el.id).includes(this.user.id) ||
        (this.task.assignee && this.task.assignee.id === this.user.id) ||
        (this.task.project && this.task.project.participants && this.task.project.participants.map(el => el.id).includes(this.user.id)) ||
        (this.task.project.client && this.user.clients.map(el => el.id).includes(this.task.project.client.map(el => el.id)))
      )
    },
    canDelete () {
      if (!this.task.project || !this.task.project.client) return this.user.admin
      return this.user.admin || this.user.clients.map(el => el.id).includes(this.task.project.client.id)
    }
  },
  mounted () {
    this.getTask()
    this.getDataStructures()
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  methods: {
    async getTask () {
      let r = await axios.get('/v2/tasks/' + this.$route.params.id)
      this.task = r.data
    },
    async updateProperty (val, key) {
      let data = {}
      data[key] = val
      try {
        await axios.patch(`/v2/tasks/${this.task.id}`, data)
        if (['client', 'requestedBy', 'assignee', 'project'].includes(key)) this.getTask()
        this.$toastr.success(`Task property ${key} updated`, 'Success')
        eventBus.$emit('loadHistory')
      } catch (error) {
        this.$toastr.error('Failed to update Task', error)
      }
    },
    async deleteTask () {
      if (confirm(`Are you sure you want to delete ${this.task.title}?`)) {
        try {
          await axios.delete(`/v2/tasks/${this.task.id}`)
          this.$toastr.success('You will be redirected to tasks page', 'Task deleted!')
          this.$router.push('/task-manager/tasks')
          eventBus.$emit('loadHistory')
        } catch (error) {
          this.$toastr.error('Failed to delete task', error)
        }
      }
    },
    async editStatus () {
      if (!this.statusMessage.trim().length || !this.task.status) {
        this.$toastr.warning('Status and message are mandatory fields')
        return
      }
      this.updateProperty(this.task.status, 'status')
      let data = {
        type: 'action',
        message: this.statusMessage,
        targets: [{ type: 'tasks', id: this.task.id }],
        data: { action: 'status-update' }
      }
      await axios.post('/v2/messages', data)
      $('#edit-status').modal('hide')
    },
    getDataStructures () {
      const difference = ['projectmanager-task-statuses', 'projectmanager-task-priorities', 'departments'].filter(k => !Object.keys(this.dataStructure).includes(k))
      if (difference.length) {
        this.$store.dispatch('fetchMultipleData', difference.join(','))
          .then(() => {
            this.assignDataStructures()
          })
      } else {
        this.assignDataStructures()
      }
    },
    assignDataStructures () {
      this.status = this.dataStructure['projectmanager-task-statuses']['values']
      this.departments = this.dataStructure['departments']['values']
      this.priority = this.dataStructure['projectmanager-task-priorities']['values']
    },
    toggleEdit (id) {
      const idToShow = id.includes('data') ? id.replace('data', 'edit') : id.replace('edit', 'data')
      this.hideData(id)
      this.showData(idToShow)
    },
    showData (id) {
      document.getElementById(id).style.display = 'block'
    },
    hideData (id) {
      document.getElementById(id).style.display = 'none'
    }
  }
}
</script>
<style scoped>
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.large-font {
  font-size: large;
}
.display-block {
  display: block;
}
.inline-block {
  display: inline-block;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Single/Content/Tabs/TaskData.vue